// COMMON Types
export const UPDATE_LOADER = "UPDATE_LOADER";
export const UPDATE_LEFT_MENU = "UPDATE_LEFT_MENU";
export const UPDATE_RIGHT_MENU = "UPDATE_RIGHT_MENU";

export const GET_AI_MATURITY_EVALUATION = "GET_AI_MATURITY_EVALUATION";
export const UPDATE_REVENUE_REPORT = 'UPDATE_REVENUE_REPORT';
export const UPDATE_COMPANY_INFO_STATUS = "UPDATE_COMPANY_INFO_STATUS";